// extracted by mini-css-extract-plugin
module.exports = {"skills-container":"_1EITRo16biu0pyegKUgC7","tag-container":"nhpXDSshYT5SxBQe8XYHe","tag-group-container":"VSWRL7Cv2OCWE7NRBcfU9"};